import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Stack, Text, Modal, ScreenWidthMinXLarge, ScreenWidthMinLarge, mergeStyleSets, PrimaryButton } from '@fluentui/react';
import { NeutralColors } from '@fluentui/theme';
import consentSuccessModalIcon from '@shared/images/consentSuccessModalIcon.png';
import { Constants } from '@shared/utils/constants';
import { getNpsModule } from '@appsource/utils/nps';
const successConsentModalClassNames = mergeStyleSets({
    description: {
        display: 'flex',
        textAlign: 'center',
        flexDirection: 'column'
    },
    centeredText: {
        textAlign: 'center'
    },
    imgSize: {
        width: 100,
        height: 100
    }
});
const iconButtonStyles = {
    root: {
        color: NeutralColors.gray160
    }
};
const modalStyles = {
    main: {
        [`@media (min-width: ${ScreenWidthMinXLarge}px)`]: {
            width: '28%'
        },
        [`@media (min-width: ${ScreenWidthMinLarge}px) and (max-width: ${ScreenWidthMinXLarge}px)`]: {
            width: '50%'
        },
        [`@media (max-width: ${ScreenWidthMinLarge}px)`]: {
            width: '80%'
        },
        display: 'flex',
        maxWidth: 560
    },
    scrollableContent: {
        padding: '16px 27px 24px 24px',
        [`@media (max-width: ${ScreenWidthMinLarge}px)`]: {
            padding: '16px 20px 24px 20px'
        }
    }
};
const cancelIcon = {
    iconName: 'Cancel'
};
const titleAndContentTokens = {
    childrenGap: 60
};
const descriptionAndIconTokens = {
    childrenGap: 20
};
const descriptionTokens = {
    maxWidth: 280
};
const contentAndBottomTokens = {
    childrenGap: 66
};
export const SuccessConsentModal = ({ publisher, dismissModal, shouldSkipModal }, context)=>{
    return /*#__PURE__*/ _jsx(Modal, {
        isOpen: !shouldSkipModal,
        onDismiss: dismissModal,
        styles: modalStyles,
        children: /*#__PURE__*/ _jsxs(Stack, {
            tokens: titleAndContentTokens,
            children: [
                /*#__PURE__*/ _jsx(Stack.Item, {
                    children: /*#__PURE__*/ _jsxs(Stack, {
                        horizontal: true,
                        children: [
                            /*#__PURE__*/ _jsx(Stack.Item, {
                                grow: true,
                                className: successConsentModalClassNames.centeredText,
                                children: /*#__PURE__*/ _jsx(Text, {
                                    variant: "xLarge",
                                    children: context.loc('Consent_Modal_Success_Title', 'Thanks for getting in touch!')
                                })
                            }),
                            /*#__PURE__*/ _jsx(Stack.Item, {
                                children: /*#__PURE__*/ _jsx(IconButton, {
                                    styles: iconButtonStyles,
                                    iconProps: cancelIcon,
                                    ariaLabel: "close",
                                    onClick: dismissModal
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Stack.Item, {
                    children: /*#__PURE__*/ _jsxs(Stack, {
                        tokens: contentAndBottomTokens,
                        children: [
                            /*#__PURE__*/ _jsx(Stack.Item, {
                                children: /*#__PURE__*/ _jsxs(Stack, {
                                    horizontalAlign: "center",
                                    tokens: descriptionAndIconTokens,
                                    children: [
                                        /*#__PURE__*/ _jsx(Stack.Item, {
                                            children: /*#__PURE__*/ _jsx("img", {
                                                src: consentSuccessModalIcon,
                                                alt: context.loc('Success_Consent_Modal_Icon_Name'),
                                                className: successConsentModalClassNames.imgSize
                                            })
                                        }),
                                        /*#__PURE__*/ _jsxs(Stack.Item, {
                                            tokens: descriptionTokens,
                                            className: successConsentModalClassNames.description,
                                            children: [
                                                /*#__PURE__*/ _jsxs(Text, {
                                                    variant: "large",
                                                    children: [
                                                        context.loc('Success_Consent_Modal_Someone_From', `Someone from`),
                                                        " ",
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            variant: "large",
                                                            className: "ms-fontWeight-bold",
                                                            children: publisher
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx(Text, {
                                                    variant: "large",
                                                    className: "ms-fontWeight-semibold",
                                                    children: context.loc('Success_Consent_Modal_Will_Contact_You', 'will contact you soon.')
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Stack.Item, {
                                align: "end",
                                children: /*#__PURE__*/ _jsx(PrimaryButton, {
                                    text: context.loc('Dialog_Close'),
                                    onClick: ()=>{
                                        var _getNpsModule;
                                        dismissModal();
                                        (_getNpsModule = getNpsModule()) === null || _getNpsModule === void 0 ? void 0 : _getNpsModule.ctaClicked();
                                    },
                                    "data-bi-id": Constants.JsllCTAId.Close,
                                    "data-bi-area": "Consent Dialog"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
SuccessConsentModal.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func
};
